import { render, staticRenderFns } from "./PontuacaoFiscais.vue?vue&type=template&id=b7a7ed76&lang=pug&"
import script from "./PontuacaoFiscais.vue?vue&type=script&lang=js&"
export * from "./PontuacaoFiscais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports